package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val uid: String,
    val displayName: String,
    val photoUrl: String? = null,
    val isShadow: Boolean = false,
    val isSetupComplete: Boolean = false,
    // Mapa ról w firmach (bez finansów)
    val engagements: Map<String, EngagementDto> = emptyMap(),
    // @ServerTimestamp w implementacji Firestore
    val createdAt: String,
    /** SH-138: the app language (picked, else the device's), read by the functions. */
    val language: String? = null,
    /** SH-137: the language picked in the app; absent: the device's. */
    val languagePreference: String? = null,
    /** SH-196: the app colours picked by the person; absent: never picked. */
    val appearance: AppearanceDto? = null
)

/** SH-196: users/{uid}.appearance: the names of a ThemeBase and a ThemeAccent. */
@Serializable
data class AppearanceDto(
    val base: String? = null,
    val accent: String? = null
)


@Serializable
data class EngagementDto(
    val role: String?,

    // To pole jest potrzebne, żeby Mapper miał skąd brać nazwę (cachedWorkplaceName)
    val workplaceName: String? = null,

    // BRAKUJĄCE POLE:
    val skills: List<String> = emptyList(),

    val permission: String, // Przechowujemy jako String (np. "OWNER")
    val isActive: Boolean = true,
    val startDate: String? = null,
    val endDate: String? = null,
    val isPrimary: Boolean = false,
    /** SH-47: Competence name (INDEPENDENT, NEEDS_SUPERVISION). */
    val competence: String = "INDEPENDENT",
    /**
     * SH-268: a group manager's grant (functions/groupManagers.js writes these): the group, its
     * name, the level it gives and the person's own engagement kept underneath. Read and written
     * back as they are, so an app writing the whole engagement keeps them.
     */
    val viaGroupId: String? = null,
    val viaGroupName: String? = null,
    val groupPermission: String? = null,
    val direct: DirectEngagementDto? = null,
    /** SH-268: ended when a group's grant went. */
    val formerGroupId: String? = null,
    /**
     * SH-270: the feature access (functions/permissions.js writes it, the rules refuse it from
     * the app). Read; written back only as null (EngagementMapper.toDto), which the rules accept
     * as dropping it: the function puts it back.
     */
    val access: EngagementAccessDto? = null
)

/** SH-270: engagements[wp].access: role, modifications, grants (permission -> feature -> level). */
@Serializable
data class EngagementAccessDto(
    val roleId: String = "",
    val roleName: String? = null,
    val overrides: Map<String, Int> = emptyMap(),
    val grants: Map<String, Map<String, Int>> = emptyMap()
)

/** SH-268: engagements[wp].direct: the person's own engagement under a group's grant. */
@Serializable
data class DirectEngagementDto(
    val permission: String = "EMPLOYEE",
    val isActive: Boolean = true,
    val endDate: String? = null
)